const state = {
    promotions: null,
    types: {
        'โปรโมชันผ่านช่องทางหน้าร้าน': '#358B22',
        'โปรโมชันผ่านช่องทางเดลิเวอรี': '#1D4DD1',
        'โปรโมชันผ่านช่องทาง Café Amazon App': '#FDB913',
        'โปรโมชันจากพาร์ทเนอร์': '#E07739',
        'กิจกรรมอื่นๆ': '#637381',
    },
}

const getters = {
    getPromotions(state) {
        return state.promotions && state.promotions.items
    },
    getPromotionsByType(state) {
        return (type) => state.promotions && state.promotions.items.filter(promotion => {
            return promotion.PromotionType__c == type})
    },
    getTypes(state) {
        return state.types
    },
    getTypeKeys(state) {
        return Object.keys(state.types)
    }
}

const actions = {
}

const mutations = {
    setPromotions(state, promotions) {
        const types = Object.keys(state.types)
        promotions.items.sort((a, b) => {
            const typeA = types.indexOf(a.PromotionType__c),
                  typeB = types.indexOf(b.PromotionType__c)
            if (typeA !== typeB) {
                if (typeA === -1) return 1
                if (typeB === -1) return -1
                return typeA < typeB ? -1 : 1
            }

            const noendA = !('EndDate__c' in a),
                  noendB = !('EndDate__c' in b)
            if (noendA !== noendB) {
                return noendA < noendB ? -1 : 1
            }

            if (a.StartDate__c !== b.StartDate__c) {
                return a.StartDate__c < b.StartDate__c ? -1 : 1
            }

            if (!noendA && !noendB && a.EndDate__c !== b.EndDate__c) {
                return a.EndDate__c < b.EndDate__c ? -1 : 1
            }
            return 0
        })
        state.promotions = promotions
    },
    initTypes(state) {
        state.types =  {
            'โปรโมชันผ่านช่องทางหน้าร้าน': '#358B22',
            'โปรโมชันผ่านช่องทางเดลิเวอรี': '#1D4DD1',
            'โปรโมชันผ่านช่องทาง Café Amazon App': '#FDB913',
            'โปรโมชันจากพาร์ทเนอร์': '#E07739',
            'กิจกรรมอื่นๆ': '#637381',
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
